import { DialogClose, DialogOverlay } from 'components/dialog';
import { nanoid } from 'nanoid';
import { FC, useRef } from 'react';
import { InfographicDialogContent } from './infographic-dialog.styles';
interface Props {
  showDialog: boolean;
  closeDialog: any;
}

const InfographicDialog: FC<Props> = ({
  showDialog,
  children,
  closeDialog,
}) => {
  const id = useRef(nanoid());

  return (
    <DialogOverlay isOpen={showDialog} onDismiss={closeDialog} id={id.current}>
      <InfographicDialogContent aria-labelledby='dialog-title'>
        {children}
        <DialogClose onClick={closeDialog} iconDimensions={24}>
          Close
        </DialogClose>
      </InfographicDialogContent>
    </DialogOverlay>
  );
};

export default InfographicDialog;
